// ===== Packages =====

import styled       from 'styled-components';

// ===== General Constants =====

import {
    CURSOR_Z_INDEX,
    BODY_FONT_SIZE,
    MODAL_Z_INDEX,
}                   from '../../constants/generalConstants';

interface ModalContainerProps {
    color?: string,
    width?: number,
    isVisible: boolean,
    customCursorActive: boolean,
}
export const ModalContainer = styled.div<ModalContainerProps>`
    width: ${({ width }) => (width
        ? `${width}px`
        : `${37.5 * BODY_FONT_SIZE}px`
    )};
    max-width: calc(100vw - ${`${2 * BODY_FONT_SIZE}px`});
    height: auto;
    max-height: 80%;
    background-color: ${({ color, theme }) => color || theme.verascopeColor.purple300};
    position: fixed;
    left: 50%;
    top: 0;
    will-change: transform;
    box-shadow: ${({ theme }) => theme.color.boxShadow300};
    border-radius: ${`${0.3125 * BODY_FONT_SIZE}px`};
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch; /* smooth scrolling for iOS */
    touch-action: pan-y;
    overflow-x: hidden;
    z-index: ${MODAL_Z_INDEX};
    padding: ${`${2.5 * BODY_FONT_SIZE}px`};
    box-sizing: border-box;
    pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
    cursor: ${({ customCursorActive }) => (customCursorActive ? 'none' : 'default')};

    ${({ theme }) => theme.mediaQuery.small} {
        margin-left: 0;
        width: ${`${37.5 * BODY_FONT_SIZE}px`};
        padding: ${`${2 * BODY_FONT_SIZE}px`};
    }

    ${({ theme }) => theme.mediaQuery.extraSmall} {
        margin-left: 0;
        width: ${`${21.875 * BODY_FONT_SIZE}px`};
        padding: ${`${1.25 * BODY_FONT_SIZE}px`};
    }
`;

interface ModallessContainerProps {
    isVisible: boolean,
}
export const ModallessContainer = styled.div<ModallessContainerProps>`
    position: fixed;
    left: 50%;
    top: 0;
    z-index: ${CURSOR_Z_INDEX - 1};
    pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
`;
